export default {
  "dashboard.title": "Bentornato",
  "dashboard.noAccount.title": "Aggiungi il Tuo Conto PAMM",
  "dashboard.noAccount.description": "Hai bisogno di un conto di investimento PAMM attivo per attivare il tuo utente e godere dei benefici di TheClub",
  "dashboard.noAccount.skipButton": "Salta",
  "dashboard.noAccount.addAccountButton": "Aggiungi Conto PAMM",
  "dashboard.subtitle": "Costruisca il suo futuro con The Club",
  "dashboard.totalEarnings.lifetime": "Guadagni Totali",
  "dashboard.totalEarnings.lastMonth": "Guadagni Totali",
  "dashboard.totalEarnings.breakdown.accounts": "Profitti del conto di trading",
  "dashboard.totalEarnings.breakdown.commissions": "Commissioni della tua Comunità",
  "dashboard.community.combined.title": "Panoramica della Mia Comunità",
  "dashboard.userInfo.combined.title": "Profilo",
  "dashboard.charts.totalEarningsOverTime": "Guadagni Totali nel Tempo",
  "dashboard.userProfile.title": "Panoramica Profilo",
  "dashboard.userProfile.username": "Nome utente",
  "dashboard.userProfile.memberSince": "Membro dal",
  "dashboard.userProfile.rank": "Rango",
  "dashboard.userProfile.status": "Stato",
  "dashboard.userStats.title": "Statistiche Rapide",
  "dashboard.userStats.referralLink": "Link di Riferimento",
  "dashboard.userStats.commissionModel": "Modello di Commissione",
  "dashboard.userStats.communityValue": "Valore Comunità",
  "dashboard.userStats.linkCopied": "Link Copiato!",
  "dashboard.userStats.linkCopiedDesc": "Link di riferimento copiato negli appunti",
  "dashboard.userStats.rank": "Rango",
  "dashboard.profits.lifetime": "Profitti complessivi del conto di trading",
  "dashboard.profits.lastMonth": "Profitti del conto di trading del mese scorso",
  "dashboard.profits.accountsProfits.title": "Profitti del conto di trading",
  "dashboard.profits.commissions.title": "Commissioni della tua Comunità",
  "dashboard.commissions.lifetime": "Commissioni Totali",
  "dashboard.commissions.lastMonth": "Commissioni",
  "dashboard.commissions.lastMonthWithMonth": "Commissioni di",
  "dashboard.commissions.currentBalance": "Saldo Attuale",
  "dashboard.commissions.totalPaid": "Totale Pagato",
  "dashboard.community.totalReferrals": "Referral Totali",
  "dashboard.community.totalReferralsDesc": "Tutti i Livelli Combinati",
  "dashboard.community.communityValue": "Valore della sua Comunità",
  "dashboard.community.communityValueDesc": "Valore Totale della sua Comunità",
  "dashboard.mycommunity.title": "La Mia Comunità",
  "dashboard.charts.profitsOverTime": "Profitti del Conto di Trading nel Tempo",
  "dashboard.charts.commissionsOverTime": "Commissioni nel Tempo",
  "dashboard.charts.accountProfit": "Profitto del Conto di Trading",
  "dashboard.charts.commissionAmount": "Importo Commissione",
  "dashboard.charts.totalEarnings": "Guadagni Totali",
  "dashboard.months.jan": "Gen",
  "dashboard.months.feb": "Feb",
  "dashboard.months.mar": "Mar",
  "dashboard.months.apr": "Apr",
  "dashboard.months.may": "Mag",
  "dashboard.months.jun": "Giu",
  "dashboard.months.jul": "Lug",
  "dashboard.months.aug": "Ago",
  "dashboard.months.sep": "Set",
  "dashboard.months.oct": "Ott",
  "dashboard.months.nov": "Nov",
  "dashboard.months.dec": "Dic",
  "dashboard.monthsFull.jan": "Gennaio",
  "dashboard.monthsFull.feb": "Febbraio",
  "dashboard.monthsFull.mar": "Marzo",
  "dashboard.monthsFull.apr": "Aprile",
  "dashboard.monthsFull.may": "Maggio",
  "dashboard.monthsFull.jun": "Giugno",
  "dashboard.monthsFull.jul": "Luglio",
  "dashboard.monthsFull.aug": "Agosto",
  "dashboard.monthsFull.sep": "Settembre",
  "dashboard.monthsFull.oct": "Ottobre",
  "dashboard.monthsFull.nov": "Novembre",
  "dashboard.monthsFull.dec": "Dicembre",
  "dashboard.loading": "Caricamento dati dashboard...",
  "dashboard.error": "Errore nel caricamento dei dati dashboard",
  "dashboard.status.active": "Attivo",
  "dashboard.status.inactive": "Inattivo",
  "dashboard.profits.lastMonthWithMonth": "Profitti del conto di trading",
};
